module.exports = __webpack_public_path__ + "static/media/landingpage-1.6a824396.svg";